import { render, staticRenderFns } from "./modal-see-more-reviews.vue?vue&type=template&id=6b6be49c"
import script from "./modal-see-more-reviews.vue?vue&type=script&lang=js"
export * from "./modal-see-more-reviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports